import React, { useState, useCallback, useMemo } from 'react';

import {
  Progress,
  Box,
  ButtonGroup,
  Button,
  Heading,
  Flex,
  FormControl,
  GridItem,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  InputLeftAddon,
  InputGroup,
  Textarea,
  FormHelperText,
  InputRightElement,
  VStack,
} from '@chakra-ui/react';



import { HStack, Stack, Text, useColorModeValue} from '@chakra-ui/react';
import { Card, CardHeader, CardBody, CardFooter } from '@chakra-ui/react';

import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

import { useToast } from '@chakra-ui/react';



import { DatePicker } from 'antd';
import { Link, useLocation } from "react-router-dom";


import Stepper from "./components/Stepper";
import StepperControl from "./components/StepperControl";
import { UseContextProvider } from "./contexts/StepperContext";

import Account from "./components/steps/Account";
import Details from "./components/steps/Details";
import Payment from "./components/steps/Payment";
import Final from "./components/steps/Final";
import Form2 from '../Registration/Form2';
import Mim from './components/steps/Mim';

import axios from 'axios';


export default function Qna() {



  const [currentStep, setCurrentStep] = useState(1);

  const {state} = useLocation();
  const {orderId} = state;

  const steps = [
    "Account Information",
    "Personal Details",
    "Payment",
    "Custom",
    "Complete",

  ];

  const displayStep = (step) => {
    switch (step) {
      case 1:
        return <Account orderId={orderId}/>;
      case 2:
        return <Details orderId={orderId}/>;
      case 3:
        return <Payment orderId={orderId}/>;
      case 4:
        return <Mim orderId={orderId}/>;
      case 5:
        return <Final orderId={orderId}/>;
      default:
    }
  };

  const handleClick = async (action) => {
    // let newStep = currentStep;

    // direction === "next" ? newStep++ : newStep--;
    // // check if steps are within bounds
    // newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);


    let newStep = currentStep;

    if (action === "next") {
      // submission logic
      // ...

      newStep++;
    } else if (action === "back") {
      newStep--;
    }
    else if(action === "confirm"){
      await axios.put('https://glb-api.onrender.com/sop/update/qnastatus', {orderId:orderId}, {withCredentials:true})
      .then(
        res => console.log("worked")
      )
      .catch(
        err => console.log(err)
      )
      newStep++;
    }

    // check if steps are within bounds
    newStep > 0 && newStep <= steps.length && setCurrentStep(newStep);
  };


  return (
    <>
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}
      >
        <Stack spacing={8} mx={'auto'} minW={'70%'} py={12} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'4xl'} textAlign={'center'}>
              SOP Review
            </Heading>
            <Text fontSize={'lg'} color={'gray.600'}>
              Fill up this form to get your SOP reviewed 📃
            </Text>
          </Stack>
          <Box
            rounded={'lg'}
            bg={useColorModeValue('white', 'gray.700')}
            boxShadow={'lg'}
            p={8}
          >

            {/* <Qna/> */}
            <div className="mx-auto rounded-2xl bg-white pb-2  ">
      {/* Stepper */}
      <div className="horizontal container mt-5 ">
        <Stepper steps={steps} currentStep={currentStep} />

        <div className="my-10 mt-20 ">
          <UseContextProvider>{displayStep(currentStep)}</UseContextProvider>
        </div>
      </div>

      {/* navigation button */}
      {currentStep !== steps.length && (
        <StepperControl
        handleClick={handleClick}
        currentStep={currentStep}
        steps={steps}
        orderId = {orderId}

        />
      )}
    </div>

          </Box>
        </Stack>
      </Flex>
    </>
  );
}
